const HOME_PATH = '/';
const ORDERS_PATH = '/orders';
const SHOPIFY_ORDERS_PATH = '/shopify-orders';
const REPORTS_PATH = '/reports';
const ACCOUNT_PATH = '/account';
const LOGIN_PATH = `${ACCOUNT_PATH}/login`;
const LOGOUT_PATH = `${ACCOUNT_PATH}/logout`;
const FORGOT_PASSWORD_PATH = `${ACCOUNT_PATH}/forgot-password`;
const RESET_PASSWORD_PATH = `${ACCOUNT_PATH}/reset-password`;

export {
  ACCOUNT_PATH,
  FORGOT_PASSWORD_PATH,
  HOME_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  ORDERS_PATH,
  REPORTS_PATH,
  RESET_PASSWORD_PATH,
  SHOPIFY_ORDERS_PATH
};
